import { createContext } from "react";

export const defaultErrorContext = {
    errorMessage: null,
    forSupport: null,
}

const contextDefault = {
    ...defaultErrorContext,
    setError: ({ errorMessage, forSupport }) => { }
}

export const ErrorContext = createContext(contextDefault);